<template>
  <div>
    <div class="signin-background" :style="backgroundStyle">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" class="fill-height">
          <v-col cols="12" sm="3" md="4" lg="4" xl="4">
            <v-card
              class="login-card elevation-24"
              rounded="xl"
              :style="cardStyle"
            >
              <!-- Logo and Header Section -->
              <div class="text-center pt-8 pb-6">
                <v-avatar class="mb-4 logo-avatar" size="100">
                  <img src="@/assets/jmb-logo-avatar.png" alt="JMB" />
                </v-avatar>
                <h1 class="text-h4 font-weight-bold primary--text mb-2">
                  JMBComputers
                </h1>
                <p class="text-subtitle-1 grey--text text--darken-1">
                  {{ admin_login ? "Admin User Portal" : "Customer Portal" }}
                </p>
              </div>

              <v-card-text class="px-8 pb-8">
                <!-- CUSTOMER LOGIN -->
                <!-- <div v-if="!admin_login">
                  <p class="text-center mb-6 text-body-1">
                    Enter your access code to continue
                  </p>
                  <v-text-field
                    v-model="customer_code"
                    label="Access Code"
                    placeholder="Enter your code"
                    outlined
                    dense
                    prepend-inner-icon="mdi-key"
                    class="mb-4"
                    @keyup.enter="customer_login"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    x-large
                    block
                    rounded
                    elevation="2"
                    class="mb-3"
                    @click="customer_login"
                    :loading="loading"
                  >
                    <v-icon left>mdi-login</v-icon>
                    Sign In
                  </v-btn>
                  <v-btn
                    text
                    block
                    rounded
                    class="text-none"
                    @click="admin_login = true"
                  >
                    <v-icon left small>mdi-shield-account</v-icon>
                    Admin Login
                  </v-btn>
                </div> -->

                <!-- ADMIN LOGIN -->
                <div>
                  <v-form ref="form" class="mt-4">
                    <v-text-field
                      v-model="form.username"
                      label="Username"
                      placeholder="Enter your username"
                      outlined
                      dense
                      prepend-inner-icon="mdi-account"
                      class="mb-3"
                      @keyup.enter="submit()"
                    ></v-text-field>
                    <v-text-field
                      v-model="form.password"
                      label="Password"
                      placeholder="Enter your password"
                      type="password"
                      outlined
                      dense
                      prepend-inner-icon="mdi-lock"
                      class="mb-5"
                      @keyup.enter="submit()"
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      x-large
                      block
                      rounded
                      elevation="2"
                      class="mb-3"
                      @click="submit()"
                      :loading="loading"
                    >
                      <v-icon left>mdi-login</v-icon>
                      Sign In
                    </v-btn>
                  </v-form>
                </div>
              </v-card-text>

              <v-card-text class="text-center py-3">
                <p class="caption grey--text mb-0">
                  <v-icon x-small class="mr-1">mdi-copyright</v-icon>
                  {{ new Date().getFullYear() }} JMBComputers | v{{
                    packageJson.version
                  }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="text-center">
            <div class="pa-2 mt-10 d-flex justify-center">
              <p class="caption mb-0 white--text">
                <v-icon small color="white" class="pr-2">mdi-flash</v-icon
                >Powered by: <strong>JMBComputers</strong> | Version
                {{ packageJson.version }}
                <br />
                <span class="white--text text--darken-1"
                  ><v-icon color="white" small class="pr-2">mdi-gmail</v-icon>
                  janmichaelbesinga873@gmail.com</span
                >
              </p>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <notification />
    </div>
  </div>
</template>

<script>
import packageJson from "../../package.json";
import { mapActions, mapGetters } from "vuex";
import Notification from "../components/Notification.vue";
export default {
  components: {
    Notification,
  },
  data() {
    return {
      packageJson: packageJson,
      customer_code: "",
      admin_login: true,
      form: {
        username: "",
        password: "",
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      selectedTheme: "theme/selectedTheme",
      darkMode: "theme/darkMode",
    }),
    backgroundStyle() {
      return {
        background: this.selectedTheme.gradient,
        minHeight: "100vh",
      };
    },
    cardStyle() {
      return {
        background: this.darkMode
          ? "rgba(30, 30, 30, 0.95) !important"
          : "rgba(255, 255, 255, 0.95) !important",
      };
    },
  },
  methods: {
    customer_login() {
      this.loading = true;
      this.get_customer(this.customer_code)
        .then(() => {
          this.loading = false;
          this.set_notification({
            message: "Sucessfully logged in",
            type: "success",
          });
          setTimeout(() => {
            this.$router.push("/customerDash");
          }, 1000);
        })
        .catch((err) => {
          let err_message = "";
          if (err.response && err.response.status === 404) {
            err_message = "No accounts found";
          } else if (err.response && err.response.status === 500) {
            err_message = "The portal is not in service right now";
          } else {
            err_message = "An error occurred";
          }
          this.loading = false;
          this.set_notification({ message: err_message, type: "error" });
        });
    },

    ...mapActions({
      get_customer: "customer/get_customer",
      signin: "auth/signin",
      set_notification: "notification/set_notification",
    }),
    reset() {
      (this.form.username = ""), (this.form.password = "");
    },
    submit() {
      // Block duplicate submits (Enter key stays active while the button
      // is in loading state) — each extra attempt counts against the
      // server's login throttle and can trigger a 429 lockout.
      if (this.loading) return;
      this.loading = true;
      this.signin(this.form)
        .then(() => {
          this.loading = false;
          this.$router.push("/");
        })
        .catch((err) => {
          if (err.code === "ECONNABORTED" || err.message?.includes("timeout")) {
            this.set_notification({
              message:
                "Login timed out. The server is taking too long to respond. Please try again.",
              color: "error",
              showing: true,
              icon: "mdi-clock-alert",
            });
          } else if (!err.response) {
            this.set_notification({
              message:
                "Unable to connect to server. Please check your internet connection.",
              color: "error",
              showing: true,
              icon: "mdi-wifi-off",
            });
          } else if (err.response.status == 401) {
            this.set_notification({
              message: "Username or Password Incorrect. Please try again.",
              color: "error",
              showing: true,
              icon: "mdi-alert",
            });
          } else if (err.response.status == 404) {
            this.set_notification({
              message: "Account disabled",
              color: "error",
              showing: true,
              icon: "mdi-alert",
            });
          } else {
            this.set_notification({
              message: "Something went wrong. Please contact the administrator",
              color: "red",
              showing: true,
              icon: "mdi-alert",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.signin-background {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.signin-background::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 70%
  );
  animation: pulse 15s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.1) rotate(180deg);
  }
}

.login-card {
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
}

.logo-avatar {
  border: 4px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.logo-avatar:hover {
  transform: scale(1.05) rotate(5deg);
}

/* Modern input styles */
.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(0, 0, 0, 0.3);
}

.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-width: 2px;
}

/* Button animations */
.v-btn {
  transition: all 0.3s ease;
}

.v-btn:not(.v-btn--text):hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.v-btn:not(.v-btn--text):active {
  transform: translateY(0);
}

/* Smooth transitions */
* {
  transition: opacity 0.3s ease;
}
</style>
